//import { AllModules, ColDef, GridOptions } from '@ag-grid-enterprise/all-modules';
import { ColDef, GridOptions, GridApi } from "ag-grid-community";
import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Dialog, DialogButton } from '../../../../core/models/dialog.model';
import { SubHeader } from '../../../../core/models/sub-header.model';
import { AdhocReportsService } from '../../../../admin/services/adhoc-reports-service';
import { DateService } from '../../../../common/services/date.service';
import { GridFormatterService } from '../../../../common/services/grid-formatter.service';
import { DynamicDialogService } from '../../../../core/services/dynamic-dialog.service';
import { SubHeaderService } from '../../../../core/services/sub-header.service';
import { tap } from 'rxjs/operators';
import { ReportSearchCriteria } from '../../../../admin/models/admin-reports.model';
import { PermitApplicationMonthlyTrackingReportModel, PermitsIssuedReportModel, RevenueByApplicationTypeReportModel } from '../../../../admin/models/adhoc-reports.model';

@Component({
    selector: 'app-permit-applications-report',
    templateUrl: './permit-applications-report.component.html',
    styleUrls: ['./permit-applications-report.component.scss'],
    standalone: false
})
export class PermitApplicationsReportComponent implements OnInit {
	public monthlyTrackingGridOptions: GridOptions;
	public monthlyTrackingApi?: GridApi;
	public permitsIssuedTrackingGridOptions: GridOptions;
	public permitsIssuedApi?: GridApi;
	public revenueGridOptions: GridOptions;
	public revenueGridApi?: GridApi;
  monthlyTrackingGridReportData: PermitApplicationMonthlyTrackingReportModel[];
  permitsIssuedGridReportData: PermitsIssuedReportModel[];
  revenueGridReportData: RevenueByApplicationTypeReportModel[];
  subHeader: SubHeader = new SubHeader({
      title: "Permitting Applications 2 Report",
      buttons: []
  });
  currentDate: Date = new Date();
  monthlyTrackingFromDate: Date | null;
  monthlyTrackingToDate: Date | null;
  permitsIssuedTrackingFromDate: Date | null;
  permitsIssuedTrackingToDate: Date | null;
  revenueFromDate: Date | null;
  revenueToDate: Date | null;
  subscription: Subscription = new Subscription();
  errorDialog: Dialog = new Dialog("An error has occurred.", [new DialogButton("OK", false, () => { return; })]);

  constructor(private datePipe: DatePipe,
    private readonly dateService: DateService,
    private readonly formatService: GridFormatterService,
    private readonly adhocReportService: AdhocReportsService,
    public subHeaderService: SubHeaderService,
	  public dialogService: DynamicDialogService) {
  }

  ngOnInit() {
    this.subHeaderService.updateSubHeader(this.subHeader);

    const loading = '<span class="ag-overlay-loading-center">Please wait ...</span>';
    this.monthlyTrackingFromDate = this.dateService.generateDateWithOffset(0, -12, 0);
    this.monthlyTrackingToDate = this.currentDate;
    let coldefs = this.createMonthlyTrackingColumnDefinitions();
    this.monthlyTrackingGridOptions = this.formatService.BuildDefaultGridOptionsWithColumns(coldefs, false, true, true, true);
    this.monthlyTrackingGridOptions.headerHeight = 75;
    this.monthlyTrackingGridOptions.suppressColumnVirtualisation = true;
    this.monthlyTrackingGridOptions.overlayLoadingTemplate = loading;
    this.monthlyTrackingGridOptions.pinnedBottomRowData = this.createMonthlyTrackingTotalsData(this.monthlyTrackingGridReportData);
	  this.monthlyTrackingGridOptions.onGridReady = (params) => {
		  this.monthlyTrackingApi = params.api;
	  };
	  this.monthlyTrackingGridOptions.onFirstDataRendered = (params) => {
		  if (this.monthlyTrackingApi != null) {
			  this.monthlyTrackingApi.autoSizeAllColumns();
		  }
	  };
    this.permitsIssuedTrackingFromDate = this.dateService.generateDateWithOffset(0, -12, 0);
    this.permitsIssuedTrackingToDate = this.currentDate;
    coldefs = this.createPermitsIssuedTrackingColumnDefinitions();
    this.permitsIssuedTrackingGridOptions = this.formatService.BuildDefaultGridOptionsWithColumns(coldefs, false, true, true, true);
    this.permitsIssuedTrackingGridOptions.suppressColumnVirtualisation = true;
    this.permitsIssuedTrackingGridOptions.overlayLoadingTemplate = loading;
    this.permitsIssuedTrackingGridOptions.pinnedBottomRowData = this.createPermitsIssuedTrackingTotalsData(this.permitsIssuedGridReportData);
	  this.permitsIssuedTrackingGridOptions.onGridReady = (params) => {
		  this.permitsIssuedApi = params.api;
	  };
	  this.permitsIssuedTrackingGridOptions.onFirstDataRendered = (params) => {
		  if (this.permitsIssuedApi != null) {
			  this.permitsIssuedApi.sizeColumnsToFit();
		  }
	  };
    this.revenueFromDate = this.dateService.generateDateWithOffset(0, -12, 0);
    this.revenueToDate = this.currentDate;
    coldefs = this.createRevenueColumnDefinitions();
    this.revenueGridOptions = this.formatService.BuildDefaultGridOptionsWithColumns(coldefs, false, true, true, true);
    this.revenueGridOptions.suppressColumnVirtualisation = true;
    this.revenueGridOptions.overlayLoadingTemplate = loading;
    this.revenueGridOptions.pinnedBottomRowData = this.createRevenueTotalsData(this.revenueGridReportData);
	  this.revenueGridOptions.onGridReady = (params) => {
		  this.revenueGridApi = params.api;
	  };
	  this.revenueGridOptions.onFirstDataRendered = (params) => {
		  if (this.revenueGridApi != null) {
			  this.revenueGridApi.autoSizeAllColumns();
		  }
	  };
    this.generateMonthlyTrackingReport();
    this.generatePemitsIssuedTrackingReport();
    this.generateRevenueReport();
  }

  public createMonthlyTrackingColumnDefinitions() {
    return [
      {
        headerClass: "wrapped",
        headerName: "Month",
        headerTooltip: "Month",
        field: "monthSubmitted",
        tooltipField: "monthSubmitted",
        filter: "agTextColumnFilter",
        filterParams: this.formatService.defaultTextFilterParams,
        minWidth: 200,
        maxWidth: 225
      },
      {
        headerClass: "wrapped",
        headerName: "Number of Applications",
        headerTooltip: "Number of Applications",
        field: "totalApplications",
        tooltipField: "totalApplications",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150,
        maxWidth: 175
      },
      {
        headerClass: "wrapped",
        headerName: "Number of Permits Issued",
        headerTooltip: "Number of Permits Issued",
        field: "permitsIssued",
        tooltipField: "permitsIssued",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150,
        maxWidth: 175
      },
      {
        headerClass: "wrapped",
        headerName: "Number of Permits Pending",
        headerTooltip: "Number of Permits Pending",
        field: "permitsPending",
        tooltipField: "permitsPending",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150,
        maxWidth: 175
      },
      {
        headerClass: "wrapped",
        headerName: "Number of Permits Canceled",
        headerTooltip: "Number of Permits Canceled",
        field: "permitsCanceled",
        tooltipField: "permitsCanceled",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150,
        maxWidth: 175
      },
      {
        headerClass: "wrapped",
        headerName: "Number of Permits Denied",
        headerTooltip: "Number of Permits Denied",
        field: "permitsDenied",
        tooltipField: "permitsDenied",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150,
        maxWidth: 175
        },
        {
            headerClass: "wrapped",
            headerName: "Stratigraphic Applications",
            headerTooltip: "Stratigraphic Applications",
            field: "stratigraphicApplications",
            tooltipField: "stratigraphicApplications",
            filter: "agNumberColumnFilter",
            filterParams: this.formatService.defaultNumberFilterParams,
            minWidth: 150,
            maxWidth: 175
        },
      {
        headerClass: "wrapped",
        headerName: "Plug & Abandon Applications",
        headerTooltip: "Plug & Abandon Applications",
        field: "plugAndAbandonApplications",
        tooltipField: "plugAndAbandonApplications",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150,
            maxWidth: 175
      },
      {
        headerClass: "wrapped",
        headerName: "Number of Applications Expedited",
        headerTooltip: "Number of Applications Expedited",
        field: "expeditedApplications",
        tooltipField: "expeditedApplications",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150,
            maxWidth: 175
      },
      
      {
        headerClass: "wrapped",
        headerName: "Expedite Fees",
        headerTooltip: "Expedite Fees",
        field: "expediteFees",
        tooltipField: "expediteFees",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        tooltipValueGetter: this.formatService.formatCurrency("expediteFees", "USD", "symbol", "1.2-2"),
        valueFormatter: this.formatService.formatCurrency("expediteFees", "USD", "symbol", "1.2-2"),
        minWidth: 150,
            maxWidth: 175
      },
      {
        headerClass: "wrapped",
        headerName: "Application Fees",
        headerTooltip: "Application Fees",
        field: "applicationFees",
        tooltipField: "applicationFees",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        tooltipValueGetter: this.formatService.formatCurrency("applicationFees", "USD", "symbol", "1.2-2"),
        valueFormatter: this.formatService.formatCurrency("applicationFees", "USD", "symbol", "1.2-2"),
        minWidth: 150,
        maxWidth: 175
      },
      {
        headerClass: "wrapped",
        headerName: "Pooling Fees",
        headerTooltip: "Pooling Fees",
        field: "poolFees",
        tooltipField: "poolFees",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        tooltipValueGetter: this.formatService.formatCurrency("poolFees", "USD", "symbol", "1.2-2"),
        valueFormatter: this.formatService.formatCurrency("poolFees", "USD", "symbol", "1.2-2"),
        minWidth: 150,
        maxWidth: 175
      },
      {
        headerClass: "wrapped",
        headerName: "Total Fees",
        headerTooltip: "Total Fees",
        field: "totalFees",
        tooltipField: "totalFees",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        tooltipValueGetter: this.formatService.formatCurrency("totalFees", "USD", "symbol", "1.2-2"),
        valueFormatter: this.formatService.formatCurrency("totalFees", "USD", "symbol", "1.2-2"),
        minWidth: 150,
        maxWidth: 175
      }
    ] as ColDef[];
  }

  public createPermitsIssuedTrackingColumnDefinitions() {
    return [
      {
        headerClass: "wrapped",
        headerName: "Program Area",
        headerTooltip: "Program Area",
        field: "programArea",
        tooltipField: "programArea",
        filter: "agTextColumnFilter",
        filterParams: this.formatService.defaultTextFilterParams,
        minWidth: 200
      },
      {
        headerClass: "wrapped",
        headerName: "Applications Received",
        headerTooltip: "Applications Received",
        field: "applicationsReceived",
        tooltipField: "applicationsReceived",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150,
        maxWidth: 175
      },
      {
        headerClass: "wrapped",
        headerName: "Permits Issued",
        headerTooltip: "Permits Issued",
        field: "permitsIssued",
        tooltipField: "permitsIssued",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150,
        maxWidth: 175
      },
      {
        headerClass: "wrapped",
        headerName: "Permits Denied",
        headerTooltip: "Permits Denied",
        field: "permitsDenied",
        tooltipField: "permitsDenied",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150,
        maxWidth: 175
      },
      {
        headerClass: "wrapped",
        headerName: "Permits Remain Pending",
        headerTooltip: "Permits Remain Pending",
        field: "permitsPending",
        tooltipField: "permitsPending",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150,
        maxWidth: 175
      }
    ] as ColDef[];
  }

  public createRevenueColumnDefinitions() {
    return [
      {
        headerClass: "wrapped",
        headerName: "Application Type",
        headerTooltip: "Application Type",
        field: "applicationType",
        tooltipField: "applicationType",
        filter: "agTextColumnFilter",
        filterParams: this.formatService.defaultTextFilterParams,
        minWidth: 200,
        maxWidth: 225
      },
      {
        headerClass: "wrapped",
        headerName: "Number of Applications",
        headerTooltip: "Number of Applications",
        field: "totalApplications",
        tooltipField: "totalApplications",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150,
        maxWidth: 175
      },
      {
        headerClass: "wrapped",
        headerName: "Number of Expedite Applications",
        headerTooltip: "Number of Expedite Applications",
        field: "totalExpeditedApplications",
        tooltipField: "totalExpeditedApplications",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        minWidth: 150,
        maxWidth: 175
      },
      {
        headerClass: "wrapped",
        headerName: "Application Fees Total",
        headerTooltip: "Application Fees Total",
        field: "applicationFees",
        tooltipField: "applicationFees",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        tooltipValueGetter: this.formatService.formatCurrency("applicationFees", "USD", "symbol", "1.2-2"),
        valueFormatter: this.formatService.formatCurrency("applicationFees", "USD", "symbol", "1.2-2"),
        minWidth: 150,
        maxWidth: 175
      },
      {
        headerClass: "wrapped",
        headerName: "Pool Fees Total",
        headerTooltip: "Pool Fees Total",
        field: "poolFees",
        tooltipField: "poolFees",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        tooltipValueGetter: this.formatService.formatCurrency("poolFees", "USD", "symbol", "1.2-2"),
        valueFormatter: this.formatService.formatCurrency("poolFees", "USD", "symbol", "1.2-2"),
        minWidth: 150,
        maxWidth: 175
      },
      {
        headerClass: "wrapped",
        headerName: "Expedite Fee Total",
        headerTooltip: "Expedite Fee Total",
        field: "expediteFees",
        tooltipField: "expediteFees",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        tooltipValueGetter: this.formatService.formatCurrency("expediteFees", "USD", "symbol", "1.2-2"),
        valueFormatter: this.formatService.formatCurrency("expediteFees", "USD", "symbol", "1.2-2"),
        minWidth: 150,
        maxWidth: 175
      },
      {
        headerClass: "wrapped",
        headerName: "Total Fees",
        headerTooltip: "Total Fees",
        field: "totalFees",
        tooltipField: "totalFees",
        filter: "agNumberColumnFilter",
        filterParams: this.formatService.defaultNumberFilterParams,
        tooltipValueGetter: this.formatService.formatCurrency("totalFees", "USD", "symbol", "1.2-2"),
        valueFormatter: this.formatService.formatCurrency("totalFees", "USD", "symbol", "1.2-2"),
        minWidth: 150,
        maxWidth: 175
      }
    ] as ColDef[];
  }

  generateMonthlyTrackingReport() {
    if (this.monthlyTrackingApi) {
		this.monthlyTrackingApi.setGridOption("loading", true);
    }

    const criteria = new ReportSearchCriteria();
      criteria.fromDate = this.monthlyTrackingFromDate;
      criteria.toDate = this.monthlyTrackingToDate;

    this.subscription = this.adhocReportService.getPermitApplicationsMonthlyTrackingReportData(criteria).pipe(
        tap((data) => {
        this.monthlyTrackingGridReportData = data;
      })).subscribe({
        next: (success) => {
          if (this.monthlyTrackingApi != null) {
            this.monthlyTrackingApi.setGridOption("rowData", this.monthlyTrackingGridReportData);
		        this.monthlyTrackingApi.setGridOption("pinnedBottomRowData", this.createMonthlyTrackingTotalsData(this.monthlyTrackingGridReportData));
		        this.monthlyTrackingApi.setGridOption("loading", false);
		        this.monthlyTrackingApi.autoSizeAllColumns();
          }
      }, 
        error: (fail) => {
          console.error(fail);
          if (this.monthlyTrackingApi != null) {
            this.monthlyTrackingApi.setGridOption("loading", false);
          }
          this.showError();
        }
      });
  }

  generatePemitsIssuedTrackingReport() {
    const opt = this.permitsIssuedTrackingGridOptions;

    if (this.permitsIssuedApi != null) {
      this.permitsIssuedApi.setGridOption("loading", true);
    }

    const criteria = new ReportSearchCriteria();
      criteria.fromDate = this.permitsIssuedTrackingFromDate;
      criteria.toDate = this.permitsIssuedTrackingToDate;

    this.subscription = this.adhocReportService.getPermitIssuedByProgramAreaReportData(criteria).pipe(
        tap((data) => {
        this.permitsIssuedGridReportData = data;
      })).subscribe({
        next: (success) => {
		      if (this.permitsIssuedApi != null) {
            this.permitsIssuedApi.setGridOption("rowData", this.permitsIssuedGridReportData);
		        this.permitsIssuedApi.setGridOption("pinnedBottomRowData", this.createPermitsIssuedTrackingTotalsData(this.permitsIssuedGridReportData));
		        this.permitsIssuedApi.setGridOption("loading", false);
		        this.permitsIssuedApi.autoSizeAllColumns();
          }
      }, 
        error: (fail) => {
          console.error(fail);
          if (this.permitsIssuedApi != null) {
            this.permitsIssuedApi.setGridOption("loading", false);
          }
          this.showError();
      }
  });
  }

  generateRevenueReport() {
    if (this.revenueGridApi != null) {
		  this.revenueGridApi.setGridOption("loading", true);
    }

    const criteria = new ReportSearchCriteria();
      criteria.fromDate = this.revenueFromDate;
      criteria.toDate = this.revenueToDate;

    this.subscription = this.adhocReportService.getRevenueByApplicationTypeReportData(criteria).pipe(
        tap((data) => {

        this.revenueGridReportData = data;
      })).subscribe({
          next: (success) => {
            if (this.revenueGridApi != null) {
              this.revenueGridApi.setGridOption("rowData", this.revenueGridReportData);
		          this.revenueGridApi.setGridOption("pinnedBottomRowData", this.createRevenueTotalsData(this.revenueGridReportData));
		          this.revenueGridApi.setGridOption("loading", false);
		          this.revenueGridApi.autoSizeAllColumns();
            }
        }, 
        error: (fail) => {
            console.error(fail);
            if (this.revenueGridApi != null) {
              this.revenueGridApi.setGridOption("loading", false);
            }
            this.showError();
        }

      });
  }

    public createMonthlyTrackingTotalsData(data: any[]) {
        const result = [], label = "Total";
        if (!data) {
            result.push({
                monthSubmitted: label, totalApplications: 0, expeditedApplications: 0, permitsIssued: 0, expediteFees: 0, 
                applicationFees: 0, poolFees: 0, totalFees: 0, plugAndAbandonApplications: 0, stratigraphicApplications: 0
            });
            return result;
        }
        result.push({
            monthSubmitted: label,
            totalApplications: data.reduce((prev, cur) => { return prev + parseInt(cur.totalApplications) }, 0),
            expeditedApplications: data.reduce((prev, cur) => { return prev + parseInt(cur.expeditedApplications) }, 0),
            permitsIssued: data.reduce((prev, cur) => { return prev + parseInt(cur.permitsIssued) }, 0),
            permitsPending: data.reduce((prev, cur) => { return prev + parseInt(cur.permitsPending) }, 0),
            permitsCanceled: data.reduce((prev, cur) => { return prev + parseInt(cur.permitsCanceled) }, 0),
            permitsDenied: data.reduce((prev, cur) => { return prev + parseInt(cur.permitsDenied) }, 0),
            expediteFees: data.reduce((prev, cur) => { return prev + parseFloat(cur.expediteFees) }, 0),
            applicationFees: data.reduce((prev, cur) => { return prev + parseFloat(cur.applicationFees) }, 0),
            poolFees: data.reduce((prev, cur) => { return prev + parseFloat(cur.poolFees) }, 0),
            totalFees: data.reduce((prev, cur) => { return prev + parseFloat(cur.totalFees) }, 0),
            plugAndAbandonApplications: data.reduce((prev, cur) => { return prev + parseInt(cur.plugAndAbandonApplications) }, 0),
            stratigraphicApplications: data.reduce((prev, cur) => { return prev + parseInt(cur.stratigraphicApplications) }, 0)
        });
        return result;
    }

  public createPermitsIssuedTrackingTotalsData(data: any[]) {
    const result = [], label = "Total Permit Activity";
    if (!data) {
      result.push({
        programArea: label, applicationsReceived: 0, permitsIssued: 0, permitsDenied: 0, permitsPending: 0
      });
      return result;
    }
    result.push({
      programArea: label,
      applicationsReceived: data.reduce((prev, cur) => { return prev + parseInt(cur.applicationsReceived)}, 0),
      permitsIssued: data.reduce((prev, cur) => { return prev + parseInt(cur.permitsIssued)}, 0),
      permitsDenied: data.reduce((prev, cur) => { return prev + parseInt(cur.permitsDenied)}, 0),
      permitsPending: data.reduce((prev, cur) => { return prev + parseInt(cur.permitsPending)}, 0)
    });
    return result;
  }

  public createRevenueTotalsData(data: any[]) {
    const result = [], label = "Total";
    if (!data) {
      result.push({
        applicationType: label, totalApplications: 0, totalExpeditedApplications: 0, applicationFees: 0, poolFees: 0, expediteFees: 0, totalFees: 0
      });
      return result;
    }
    result.push({
      applicationType: label,
      totalApplications: data.reduce((prev, cur) => { return prev + parseInt(cur.totalApplications)}, 0),
      totalExpeditedApplications: data.reduce((prev, cur) => { return prev + parseInt(cur.totalExpeditedApplications)}, 0),
      applicationFees: data.reduce((prev, cur) => { return prev + parseFloat(cur.applicationFees)}, 0),
      poolFees: data.reduce((prev, cur) => { return prev + parseFloat(cur.poolFees)}, 0),
      expediteFees: data.reduce((prev, cur) => { return prev + parseFloat(cur.expediteFees)}, 0),
      totalFees: data.reduce((prev, cur) => { return prev + parseFloat(cur.totalFees)}, 0)
    });
    return result;
  }

  downloadMonthlyTrackingReport() {
    const criteria = new ReportSearchCriteria();
    criteria.fromDate = this.monthlyTrackingFromDate;
    criteria.toDate = this.monthlyTrackingToDate;
    let fileName = "PermitApplicationsMonthlyTrackingReport";
    if (this.monthlyTrackingFromDate && this.monthlyTrackingToDate) {
      const fromDate = this.datePipe.transform(this.monthlyTrackingFromDate, "yyyy-MM-dd");
      const toDate = this.datePipe.transform(this.monthlyTrackingToDate, "yyyy-MM-dd");
      fileName = `PermitApplicationsTrackingSummaryReport_${fromDate}_${toDate}`;
    }
    
    const sheetName = "Permit Applications Monthly";
    this.formatService.exportDataToExcel(fileName, sheetName, this.monthlyTrackingApi);
  }

  downloadPermitsIssuedTrackingReport() {
    const criteria = new ReportSearchCriteria();
    criteria.fromDate = this.permitsIssuedTrackingFromDate;
    criteria.toDate = this.permitsIssuedTrackingToDate;
    let fileName = "PermitsIssuedTrackingReport";
    if (this.permitsIssuedTrackingFromDate && this.permitsIssuedTrackingToDate) {
      const fromDate = this.datePipe.transform(this.permitsIssuedTrackingFromDate, "yyyy-MM-dd");
      const toDate = this.datePipe.transform(this.permitsIssuedTrackingToDate, "yyyy-MM-dd");
      fileName = `PermitsIssuedTrackingReport_${fromDate}_${toDate}`;
    }
    
    const sheetName = "Permits By Program Area";
    this.formatService.exportDataToExcel(fileName, sheetName, this.permitsIssuedApi);
  }

  downloadRevenueReport() {
    const criteria = new ReportSearchCriteria();
    criteria.fromDate = this.revenueFromDate;
    criteria.toDate = this.revenueToDate;
    let fileName = "RevenueByApplicationTypeReport";
    if (this.revenueFromDate && this.revenueToDate) {
      const fromDate = this.datePipe.transform(this.revenueFromDate, "yyyy-MM-dd");
      const toDate = this.datePipe.transform(this.revenueToDate, "yyyy-MM-dd");
      fileName = `RevenueByApplicationTypeReport_${fromDate}_${toDate}`;
    }
    
    const sheetName = "Revenue by Application Type";
    this.formatService.exportDataToExcel(fileName, sheetName, this.revenueGridApi);
  }

  get invalidDateCombinationMonthlyTracking(): boolean {
    let invalid: boolean = false;
    if (this.monthlyTrackingFromDate != null && this.monthlyTrackingToDate != null) {
        invalid = this.monthlyTrackingToDate < this.monthlyTrackingFromDate;
    }
    return invalid;
  }

  get invalidDateCombinationPermitsIssued(): boolean {
    let invalid: boolean = false;
    if (this.permitsIssuedTrackingFromDate != null && this.permitsIssuedTrackingToDate != null) {
      invalid = this.permitsIssuedTrackingToDate < this.permitsIssuedTrackingFromDate;
    }
    return invalid;
  }

  get invalidDateCombinationRevenue(): boolean {
    let invalid: boolean = false;
    if (this.revenueFromDate != null && this.revenueToDate != null) {
      invalid = this.revenueToDate < this.revenueFromDate;
    }
    return invalid;
  }

  fromDateChanged(model: Date, grid: string): void {
    switch (grid) {
      case "monthlyTrackingGrid":
        this.monthlyTrackingFromDate = model;
        break;
      case "permitsIssuedGrid":
        this.permitsIssuedTrackingFromDate = model;
        break;
      case "revenueGrid":
        this.revenueFromDate = model;
        break;
    }
  }

  toDateChanged(model: Date, grid: string): void {
    switch (grid) {
      case "monthlyTrackingGrid":
        this.monthlyTrackingToDate = model;
        break;
      case "permitsIssuedGrid":
        this.permitsIssuedTrackingToDate = model;
        break;
      case "revenueGrid":
        this.revenueToDate = model;
        break;
    }
  }

  onFilterChangedMonthlyTracking(params: any): void {
    let rowData: any[] = [];
    if (this.monthlyTrackingApi != null) {
      this.monthlyTrackingApi.forEachNodeAfterFilter(node => {
        rowData.push(node.data);
      });
	    this.monthlyTrackingApi.setGridOption("pinnedBottomRowData", this.createMonthlyTrackingTotalsData(rowData));
    }
  }

  onFilterChangedPermitsIssuedTracking(params: any): void {
    let rowData: any[] = [];
    if (this.permitsIssuedApi != null) {
      this.permitsIssuedApi.forEachNodeAfterFilter(node => {
        rowData.push(node.data);
      });
      this.permitsIssuedApi.setGridOption("pinnedBottomRowData", this.createPermitsIssuedTrackingTotalsData(rowData));
    }
  }

  onFilterChangedRevenue(params: any): void {
    let rowData: any[] = [];
    if (this.revenueGridApi != null) {
      this.revenueGridApi.forEachNodeAfterFilter(node => {
        rowData.push(node.data);
      });
      this.revenueGridApi.setGridOption("pinnedBottomRowData", this.createRevenueTotalsData(rowData));
    }
  }

  showError(): void {
    this.errorDialog.toggleDialog(true);
    this.dialogService.updateDialog(this.errorDialog);
  }

}
